function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke:#EEEBE4;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#EEEBE4;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#EEEBE4;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#EEEBE4;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#EEEBE4;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:3;}\n");

var _ref3 = /*#__PURE__*/React.createElement("polyline", {
  className: "st1",
  points: "16,12 16,18 20,15 "
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M4.3,6.3c-1.8,1.8-1.8,4.6,0,6.4l6.4-6.4C8.9,4.6,6.1,4.6,4.3,6.3z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M27.7,6.3c-1.8-1.8-4.6-1.8-6.4,0l6.4,6.4C29.4,10.9,29.4,8.1,27.7,6.3z"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 6,
  y1: 28,
  x2: 8,
  y2: 26
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 26,
  y1: 28,
  x2: 24,
  y2: 26
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 16,
  cy: 18,
  r: 9
});

var SvgTimerClock = function SvgTimerClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimerClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timerClock.d2873f3e.svg";
export { ForwardRef as ReactComponent };